import { Button, Typography, Grid } from '@mui/material';
import MainCard from 'components/MainCard';
import { Link } from 'react-router-dom';

interface NotFoundProps {
  icon: React.ComponentType<any> | null;
  text: string | any;
  link: string | null;
  categoryData?: Array<any>;
}

function NotFound({ icon: IconComponent, text, link }: NotFoundProps) {
  return (
    <MainCard sx={{ width: '100%', textAlign: 'center' }}>
      <Grid container sx={{ py: '110px' }}>
        <Grid item xs={12}>
          {IconComponent && <IconComponent size="200" color="#3a568f" variant="Bold" />}
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mt: -1, mb: 1 }}>
            {text}
          </Typography>
          {link ? (
            <Link to={link}>
              <Button sx={{ my: 1, px: 3, backgroundColor: '#3a568f', pointerEvents: 'none' }} variant="contained">
                + Add
              </Button>
            </Link>
          ) : null}
        </Grid>
      </Grid>
    </MainCard>
  );
}

export default NotFound;
